export default __webpack_public_path__ + "static/media/invite-friends-600.bbecef24.jpg";